export default __webpack_public_path__ + "static/media/perro1.af975fb5.jpeg";